module.exports = __webpack_public_path__ + "static/media/atlantida.fa195ec2.jpg";